import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

export const AtalPensionYojana = () => {
  return (
    <>
      <TopBanner content={"Atal Pension Yojana"} />
      <ContentWrapper>
        <div className="text-content">
          <h2>Secure Your Retirement, One Step at a Time</h2>
          <p>
            The Atal Pension Yojana (APY) is a government-backed pension scheme
            for individuals in the unorganised sector or those who want a basic,
            guaranteed pension after retirement. You contribute regularly during
            your working years, and after the age of 60, you receive a fixed
            monthly pension for life.
          </p>

          <h3>Why Choose APY?</h3>
          <ul>
            <li>Guaranteed pension ranging from ₹1,000 to ₹5,000 per month</li>
            <li>Backed by the Government of India </li>
            <li>Auto-debit facility from savings account </li>
            <li>Tax benefits under Section 80CCD </li>
            <li>
              Designed especially for low-income earners and informal workers
            </li>
          </ul>

          <p>
            A small step today can secure your tomorrow. APY is simple, safe,
            and meant for everyone.
          </p>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default AtalPensionYojana;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
